import {
  Shield, Clock, Heart, Award, Leaf, ThumbsUp, Users, Banknote,
  Star, Home, Sparkles, CheckCircle, Zap, Phone, Mail, Calendar,
  MapPin, Settings, Bell, Gift, Truck, Package, Camera, Music
} from 'lucide-react';

export const AVAILABLE_ICONS = {
  Shield, Clock, Heart, Award, Leaf, ThumbsUp, Users, Banknote,
  Star, Home, Sparkles, CheckCircle, Zap, Phone, Mail, Calendar,
  MapPin, Settings, Bell, Gift, Truck, Package, Camera, Music
};

export const ICON_NAMES = Object.keys(AVAILABLE_ICONS) as (keyof typeof AVAILABLE_ICONS)[];

export function getIconComponent(iconName: string) {
  return AVAILABLE_ICONS[iconName as keyof typeof AVAILABLE_ICONS] || Shield;
}
